<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="true"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<div class="content-page">
    <div class="content p-1 crumbs">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Portfolio Aging Report</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    
    @if (security.permitted('reports', 'portfolio aging', 'view')) {
        <aside>            
            <form [formGroup]="form">
                <div class="form-group">
                    <select class="form-control" name="lot" id="lot-filter" formControlName="lotId">
                        <option value="0">All Lots</option>
                        @for (lot of lots; track lot.id) {
                            <option value="{{lot.id}}">{{lot.contact.name}}</option>
                        }
                    </select>
                </div>
                <div class="form-group">
                    <select class="form-control" name="sum" id="sum-filter" formControlName="sum">
                        <option value="principal">Principal Balance</option>
                        <option value="principalwithtax">Principal + Tax Balance</option>
                        <option value="payment">Payment Balance</option>
                        <option value="payoff">Payoff Balance</option>
                    </select>
                </div>
            </form>
        </aside>

        <main>
            @if (summary && (summary.companyId)) {
                <h3>{{summary.company}}</h3>
                <h4 class="text-muted">{{summary.address}}</h4>
                <h4 class="text-muted">{{summary.cityStateZip}}</h4>
                <h5>Total Aging Report for In-House Financing Receivables as of {{summary.asOf | date:'E MMM d, yyyy'}}</h5>

                <ul class="list-group list-group-horizontal justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">Total Number of Accounts</span> <span>{{summary.count | number: '1.0-0'}}</span></li>
                </ul>

                <h4>Based on {{summedBy}} Balance</h4>

                <ul class="list-group justify-content-center flexed">
                    <li class="list-group-item"><span class="text-primary">Total Current {{summedBy}} Balance</span> <span>{{balance(summary, 'current') | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Total 30 Day {{summedBy}} Balance</span> <span>{{balance(summary, 'thirtyDay') | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Total 60 Day {{summedBy}} Balance</span> <span>{{balance(summary, 'sixtyDay') | currency}}</span></li>
                    <li class="list-group-item"><span class="text-primary">Total 90 Day {{summedBy}} Balance</span> <span>{{balance(summary, 'ninetyDay') | currency}}</span></li>
                    <li class="list-group-item item-total"><span>Total {{summedBy}} Balance</span> <span>{{balance(summary, null) | currency}}</span></li>
                </ul>

                @for (item of grouped | keyvalue; track item.key) {
                    @if (lotId <= 0) {
                        <hr />

                        <h3>{{item.value.name}}</h3>
                        <h5>Total Aging Report for Receivbables as of {{item.value['summary'].asOf | date:'E MMM d, yyyy'}}</h5>

                        <ul class="list-group list-group-horizontal justify-content-center flexed">
                            <li class="list-group-item"><span class="text-primary">Total Number of Accounts</span> <span>{{item.value['count'] | number: '1.0-0'}}</span></li>
                        </ul>

                        <h4>Based on {{summedBy}} Balance</h4>

                        <ul class="list-group justify-content-center flexed">
                            <li class="list-group-item"><span class="text-primary">Total Current {{summedBy}} Balance</span> <span>{{balance(item.value['summary'], 'current') | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Total 30 Day {{summedBy}} Balance</span> <span>{{balance(item.value['summary'], 'thirtyDay') | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Total 60 Day {{summedBy}} Balance</span> <span>{{balance(item.value['summary'], 'sixtyDay') | currency}}</span></li>
                            <li class="list-group-item"><span class="text-primary">Total 90 Day {{summedBy}} Balance</span> <span>{{balance(item.value['summary'], 'ninetyDay') | currency}}</span></li>
                            <li class="list-group-item item-total"><span>Total {{summedBy}} Balance</span> <span>{{balance(item.value['summary'], null) | currency}}</span></li>
                        </ul>
                    }

                    <h5 class="text-danger">NOTE: Payment amount, Payment Number and Number of payments left does not include deferred payments or last payments.</h5>

                    <table class="table table-sm table-striped clickable">
                        <thead>
                            <tr>
                                <th scope="col">Account</th>
                                <th scope="col">Stock</th>
                                <th scope="col" class="text-right">Payment</th>
                                <th scope="col" class="text-right">Pmt #</th>
                                <th scope="col" class="text-right">Pmts Left</th>
                                <th scope="col" class="text-right">Original Amount</th>
                                <th scope="col" class="text-right">Days Late</th>
                                <th scope="col" class="text-right">Current (0-29)</th>
                                <th scope="col" class="text-right">30 Days (30-59)</th>
                                <th scope="col" class="text-right">60 Days (60-89)</th>
                                <th scope="col" class="text-right">90 Days and over</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (receivable of item.value['receivables']; track receivable.id) {
                                <tr [routerLink]="['/accounts']" [queryParams]="{type: receivable.typeId, q: receivable.stock}">
                                    <td>{{receivable.contact}}</td>
                                    <td>{{receivable.stock}}</td>
                                    <td class="text-right">{{receivable.payment | currency}}</td>
                                    <td class="text-right">{{receivable.paymentNumber | number: '1.0-0'}}</td>
                                    <td class="text-right">{{receivable.periods - receivable.paymentNumber | number: '1.0-0'}}</td>
                                    <td class="text-right">{{receivable.initialBalance | currency}}</td>
                                    <td class="text-right">{{receivable.daysPastDue | number: '1.0-0'}}</td>
                                    <td class="text-right">@if (receivable.daysPastDue < 30) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if ((receivable.daysPastDue >= 30) && (receivable.daysPastDue <= 69)) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if ((receivable.daysPastDue >= 60) && (receivable.daysPastDue <= 89)) { {{balance(receivable, null) | currency}} }</td>
                                    <td class="text-right">@if (receivable.daysPastDue >= 90) { {{balance(receivable, null) | currency}} }</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            }
        </main>
    }
</div>